<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mt-3 mb-1 text-center">

                <div :class="{active: $route.name === 'dbuy-report'}" class="report-category mb-2"
                     @click="onReportCategoryClicked('dbuy-report')">
                    <h5 class="text-white">خرید</h5>
                </div>
                <div :class="{active: $route.name === 'dsell-report'}" class="report-category mb-2"
                     @click="onReportCategoryClicked('dsell-report')">
                    <h5 class="text-white">فروش</h5>
                </div>
                <div :class="{active: $route.name === 'dinventory'}" class="report-category mb-2"
                     @click="onReportCategoryClicked('dinventory')">
                    <h5 class="text-white">موجودی</h5>
                </div>
                <div :class="{active: $route.name === 'dreceive-report'}" class="report-category mb-2"
                     @click="onReportCategoryClicked('dreceive-report')">
                    <h5 class="text-white">دریافت</h5>
                </div>
                <div :class="{active: $route.name === 'dpayment-report'}" class="report-category mb-2"
                     @click="onReportCategoryClicked('dpayment-report')">
                    <h5 class="text-white">پرداخت</h5>
                </div>
                <div :class="{active: $route.name === 'dbalance-report'}" v-if="companyType ==5" class="report-category mb-2"
                     @click="onReportCategoryClicked('dbalance-report')">
                    <h5 class="text-white">تراز آزمایشی</h5>
                </div>

            </div>
            <div class="col-lg-12 mt-2">
                <transition
                        name="fade"
                        mode="out-in"
                >
                    <router-view/>
                </transition>
            </div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'dailyreports',
        components: {},
        data() {
            return {
                companyType: "",
            }
        },
        mounted() {
            this.companyType = localStorage.getItem("companyType");
            console.log(this.companyType )
        },
        methods: {
            onReportCategoryClicked(name) {

                this.$router.push(
                    {
                        name: `${name}`,
                        params: {
                            date: "today",
                        }
                    }
                )
                ;
            }
        }
    }
</script>